module.exports = __webpack_public_path__ + "static/media/01.959ce22b.jpg";